// extracted by mini-css-extract-plugin
export default {"button":"styles_button__Hc0V6","message":"styles_message__QrjkS","error":"styles_error__oCBWL"};